export default {
  name: 'marking--articlesMap',
  apiService: 'shoes',
  apiPath: '/admin/article_map',
};